import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { EmptyState } from '../../components/EmptyState.tsx'
import { Obj } from '../../components/Obj.tsx'
import { SkCard } from '../../components/Skeleton.tsx'
import { Back, HadisBlock } from './parts.tsx'
import { dayLong, useJumat } from './perjalanan.ts'

/**
 * /perjalanan/jumat — Kabar Jumat (docs/PRD.md §6.12): the week in the user's own activity, their gratitude, a Pegangan
 * card as provision, and a Sahih hadith about Friday from the dataset. A quiet week is said warmly.
 */
export function JumatPage() {
  const { data, isPending, isError, refetch } = useJumat()
  return (
    <div className="page pj">
      <Back />
      <h1>Kabar Jumat</h1>
      {isPending && <SkCard label="Memuat Kabar Jumat" lines={6} />}
      {isError && (
        <EmptyState obj="kado" title="Belum bisa dimuat" action={<button className="btn btn-primary" onClick={() => refetch()}>Coba lagi</button>}>
          Koneksi lagi bermasalah. Cek internet kamu, lalu coba lagi.
        </EmptyState>
      )}
      {data && (
        <>
          <p className="muted" style={{ marginTop: -6 }}>
            {data.jumat ? 'Jumat ini' : 'Sepekan terakhir'}: {dayLong(data.from)}–{dayLong(data.to)}.
          </p>
          {data.sepi ? (
            <section className="card pj-sec jm-quiet reveal">
              <Obj id="bulan" size={64} className="empty-obj" />
              <p><b>Pekan ini terasa sepi, dan itu nggak apa-apa.</b></p>
              <p className="muted">Setiap pekan bisa dimulai lagi dari satu langkah kecil. Mungkin dari satu ayat hari ini, atau satu kebiasaan saja.</p>
            </section>
          ) : (
            <ul className="jm-stats reveal">
              <li className="card"><b className="num">{data.kebiasaan.pct}%</b><span>kebiasaan terjaga ({data.kebiasaan.checks} dari {data.kebiasaan.possible})</span></li>
              <li className="card"><b className="num">{data.niatSelesai}</b><span>niat selesai</span></li>
              <li className="card"><b className="num">{data.malamMuhasabah}</b><span>malam muhasabah</span></li>
              <li className="card"><b className="num">{data.hariTantangan}</b><span>hari tantangan</span></li>
            </ul>
          )}
          {data.tumbuh && <p className="jm-grow reveal">Pilar yang paling tumbuh dibanding pekan lalu: <b>{data.tumbuh.label}</b>.</p>}

          {data.syukur.length > 0 && (
            <section className="card pj-sec reveal" aria-labelledby="jm-syukur-h">
              <h2 id="jm-syukur-h">Syukurmu pekan ini</h2>
              <ul className="mh-past">{data.syukur.map((s) => <li key={s.day}><small>{dayLong(s.day)}</small>{s.text}</li>)}</ul>
            </section>
          )}

          {data.bekal && (
            <Link className="card row-card reveal" to={`/pegangan/${data.bekal.id}`}>
              <span className="ic obj-ic" aria-hidden="true"><Obj id="kado" /></span>
              <div><small>Bekal pekan depan</small>{' '}<b>{data.bekal.judul}</b>{' '}<small>{data.bekal.ref}</small></div>
              <ChevronRight className="chev" size={18} aria-hidden="true" />
            </Link>
          )}

          {data.hadis && (
            <section className="card pj-sec reveal" aria-labelledby="jm-hadis-h">
              <h2 id="jm-hadis-h">Hadis tentang hari Jumat</h2>
              <HadisBlock h={data.hadis} />
            </section>
          )}
        </>
      )}
    </div>
  )
}
